export const conditions = [
  {
    title: 'Heavy Bleeding',
    desc: 'Natural herbal support for menorrhagia, flooding, and excessive menstrual loss.',
  },
  {
    title: 'Fibroids',
    desc: 'Plant-based approaches to managing uterine fibroids and their associated symptoms.',
  },
  {
    title: 'Painful Periods',
    desc: 'Addressing dysmenorrhoea through herbal medicine, nutrition, and lifestyle.',
  },
  {
    title: 'Hormonal Imbalance',
    desc: 'Restoring hormonal rhythm naturally through targeted herbal protocols.',
  },
  {
    title: 'PCOS',
    desc: 'Holistic support for polycystic ovary syndrome, addressing root causes, not just symptoms.',
  },
  {
    title: 'Menopause',
    desc: 'Natural relief for perimenopause and menopause symptoms including hot flushes, mood, sleep, and more.',
  },
  {
    title: 'Fertility Support',
    desc: 'Preparing and supporting the body for conception through traditional and clinical herbal approaches.',
  },
  {
    title: 'Womb Health',
    desc: 'Preventative and restorative care for reproductive and womb health across all life stages.',
  },
]

export const approach = [
  {
    n: '01',
    title: 'Herbal Medicine',
    desc: 'Carefully selected plant remedies tailored to your unique hormonal and constitutional profile.',
  },
  {
    n: '02',
    title: 'Nutrition',
    desc: 'Dietary guidance rooted in both traditional wisdom and modern nutritional science.',
  },
  {
    n: '03',
    title: 'Lifestyle Guidance',
    desc: 'Practical recommendations for rest, movement, stress, and environment.',
  },
  {
    n: '04',
    title: 'Education',
    desc: 'Understanding your cycle, your body, and your health with knowledge that empowers you for life.',
  },
  {
    n: '05',
    title: 'Emotional Wellbeing',
    desc: "Recognising and addressing the emotional dimensions of women's health experiences.",
  },
  {
    n: '06',
    title: 'Traditional Knowledge',
    desc: 'Drawing on generations of African and Caribbean healing wisdom alongside clinical practice.',
  },
]
